import styled from '@emotion/styled'

import { ApiStrategyTemplate } from '../../../api/_legacy/generated-api'
import { MasterDetail, Section } from '../../../components/core-v2'
import { Errors } from '../../tradebuilder-v2/util'
import { EditStrategiesActions } from '../state/edit-strategy-slice'
import { StrategiesPanel } from './strategies-panel'
import { StrategyDetailsPanel } from './strategy-details-panel'

export type StrategiesLayoutProps = {
  actions: EditStrategiesActions
  canProceed: boolean
  errors: Errors
  saveSuccess: boolean
  selectedStrategy?: ApiStrategyTemplate
  strategies: ApiStrategyTemplate[]
}

const StyledContentSection = styled.section`
  height: calc(100vh - 119px);
`

const StrategiesLayout = ({
  actions,
  canProceed,
  errors,
  saveSuccess,
  selectedStrategy,
  strategies
}: StrategiesLayoutProps) => (
  <StyledContentSection>
    <MasterDetail
      detailChildren={
        <Section type="quaternary">
          <StrategyDetailsPanel
            actions={actions}
            canProceed={canProceed}
            errors={errors}
            saveSuccess={saveSuccess}
            selectedStrategy={selectedStrategy}
          />
        </Section>
      }
      masterChildren={
        <Section type="primary">
          <StrategiesPanel
            selectedStrategy={selectedStrategy}
            strategies={strategies}
            onSelectStrategy={strategyTemplateId => actions.setSelectedStrategy(strategyTemplateId)}
          />
        </Section>
      }
      width="normal"
    />
  </StyledContentSection>
)

export default StrategiesLayout
